import { NgModule } from '@angular/core';
import { SharedBaseModule } from 'src/app/shared/shared-base/shared-base.module';
import { TcsUrlService } from 'src/app/shared/tcs/tcs-url.service';
import { TcsConfig } from 'src/app/shared/tcs/tcs.config';
import { TCS_CONFIG } from 'src/app/shared/tcs/tcs.config.token';
import { ModuleWithProvidersStrict } from 'src/util/angular/ng-core';

@NgModule({
  imports: [SharedBaseModule],
  declarations: [],
  providers: [],
})
export class TcsModule {
  public static forRoot(config: TcsConfig): ModuleWithProvidersStrict {
    return {
      ngModule: TcsModule,
      providers: [{ provide: TCS_CONFIG, useValue: config }, TcsUrlService],
    };
  }
}
